var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.29303 9.29259C7.48056 9.10512 7.73487 8.99981 8.00003 8.99981C8.26519 8.99981 8.5195 9.10512 8.70703 9.29259L12 12.5856L15.293 9.29259C15.3853 9.19708 15.4956 9.1209 15.6176 9.06849C15.7396 9.01608 15.8709 8.9885 16.0036 8.98734C16.1364 8.98619 16.2681 9.01149 16.391 9.06177C16.5139 9.11205 16.6255 9.18631 16.7194 9.2802C16.8133 9.37409 16.8876 9.48574 16.9379 9.60864C16.9881 9.73154 17.0134 9.86321 17.0123 9.99599C17.0111 10.1288 16.9835 10.26 16.9311 10.382C16.8787 10.504 16.8025 10.6143 16.707 10.7066L12.707 14.7066C12.5195 14.8941 12.2652 14.9994 12 14.9994C11.7349 14.9994 11.4806 14.8941 11.293 14.7066L7.29303 10.7066C7.10556 10.5191 7.00024 10.2648 7.00024 9.99959C7.00024 9.73443 7.10556 9.48012 7.29303 9.29259Z",
  fill: "#80889C"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-down.27bf11fbc4a7b10a6e1e13258b062224.svg";